export class DashboardModel {
  public id: number;
  public headUa: string = '';
  public headRu: string = '';
  public headColor: string = '';
  public bodyUa: string = '';
  public bodyRu: string = '';
  public bodyColor: string = '';
  public imageType: string = '';
  public imageBody: string = '';
  public files: File[] = [];
}
